export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";